/* Megamenu Dog Armour.
   Reglas duras aprendidas en proyectos anteriores:
   - abrir/cerrar por CLASE desde JS, nunca :hover ni :focus-within (al pulsar un
     enlace el foco se queda dentro y el panel se queda "pegado")
   - cerrar con Escape, al salir con el raton (con gracia), al hacer click fuera
     y al pulsar un enlace
   - en movil NO inyectar dentro del drawer del tema: se monta panel propio en body */
(function () {
  if (window.__darMegamenu) return;
  window.__darMegamenu = true;

  var GRACE = 120;

  function init(root) {
    if (!root || root.__init) return;
    root.__init = true;

    var items = [].slice.call(root.querySelectorAll('[data-mm-item]'));
    var overlay = root.querySelector('[data-mm-overlay]');
    var closeTimer = null;

    function closeAll() {
      items.forEach(function (it) {
        it.classList.remove('is-open');
        var t = it.querySelector('.dar-mm__trigger');
        var p = it.querySelector('[data-mm-panel]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (p) p.hidden = true;
      });
      if (overlay && !document.querySelector('.dar-mmm.is-open')) {
        overlay.classList.remove('is-on'); overlay.hidden = true;
      }
    }

    function open(it) {
      clearTimeout(closeTimer);
      items.forEach(function (o) { if (o !== it) { o.classList.remove('is-open');
        var ot = o.querySelector('.dar-mm__trigger'); if (ot) ot.setAttribute('aria-expanded', 'false');
        var op = o.querySelector('[data-mm-panel]'); if (op) op.hidden = true; } });
      var p = it.querySelector('[data-mm-panel]');
      if (p) {
        p.hidden = false;
        // forzar reflow para que la transicion arranque desde el estado cerrado.
        // NO usar requestAnimationFrame para añadir la clase: si la pestaña no
        // compone frames (segundo plano, navegador headless) el rAF no llega y
        // el panel se queda a medias, con aria-expanded=true pero sin abrir.
        void p.offsetHeight;
      }
      it.classList.add('is-open');
      var t = it.querySelector('.dar-mm__trigger');
      if (t) t.setAttribute('aria-expanded', 'true');
      // el velo NO se usa en escritorio: Yeti no oscurece la pagina al abrir el
      // megamenu, y meterlo dentro del header creaba problemas de apilamiento.
      // Se reserva para el panel movil.
    }

    /* PARPADEO: no poner mouseenter/mouseleave en CADA item. Entre la barra y el
       panel hay hueco, y al cruzarlo el raton sale del <li> -> cierra -> vuelve a
       entrar -> abre, en bucle. Se delega en el HEADER entero: mientras el raton
       siga dentro de `root` (barra o panel) no se cierra nada. */
    root.addEventListener('mouseover', function (e) {
      if (!window.matchMedia('(hover: hover)').matches) return;
      clearTimeout(closeTimer);
      // Cerrar al pasar por elementos CONCRETOS de la barra (enlaces sueltos, logo,
      // iconos). Se nombran uno a uno a proposito: cerrar en "cualquier sitio que no
      // sea un item" reintroduce el parpadeo, porque el hueco entre el boton y el
      // panel tambien es zona sin item.
      if (e.target.closest('.dar-mm__item--plain, .dar-mm__logo, .dar-mm__actions')) { closeAll(); return; }
      var it = e.target.closest('[data-mm-item]');
      if (!it) return;                                   // zona neutra: no cerrar
      if (it.classList.contains('is-open')) return;      // ya abierto: no re-abrir
      open(it);
    });
    root.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, GRACE);
    });
    root.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });

    items.forEach(function (it) {
      var trigger = it.querySelector('.dar-mm__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (it.classList.contains('is-open')) closeAll(); else open(it);
      });
      trigger.addEventListener('focus', function () {
        if (!it.classList.contains('is-open')) open(it);
      });
      // al pulsar un enlace del panel, cerrar (si no, queda abierto al volver)
      it.addEventListener('click', function (e) {
        if (e.target.closest('a')) closeAll();
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-mm-item]')) closeAll();
    });
    if (overlay) overlay.addEventListener('click', closeAll);

    buildMobile(root, items);
    publishHeaderVars(root);
  }

  /* Horizon calcula --header-height y --header-group-height en un script inline de
     theme.liquid, pero busca `header-component` (la cabecera NATIVA) y hace return
     si no existe. Como este megamenu la sustituye, esas variables se quedaban sin
     definir y otras partes del tema que dependen de ellas quedaban descolocadas.
     Aqui las publicamos nosotros y las mantenemos al redimensionar. */
  function publishHeaderVars(root) {
    var group = document.getElementById('header-group') || root.parentElement;
    function apply() {
      var h = Math.round(root.getBoundingClientRect().height);
      var gh = group ? Math.round(group.getBoundingClientRect().height) : h;
      var top = root.querySelector('.dar-mm__utility');
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', gh + 'px');
      document.body.style.setProperty('--top-row-height',
        (top ? Math.round(top.getBoundingClientRect().height) : 0) + 'px');
      // el tema lo usa para desplazar contenido bajo cabeceras transparentes
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }
    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('load', apply);
    if (window.ResizeObserver) new ResizeObserver(apply).observe(root);
  }

  /* ---- Movil: acordeon propio montado en BODY ---- */
  function buildMobile(root, items) {
    var burger = root.querySelector('[data-mm-burger]');
    if (!burger) return;

    var panel = document.createElement('div');
    panel.className = 'dar-mmm';
    panel.innerHTML = '<div class="dar-mmm__head">' +
      '<span class="dar-mmm__title">Menu</span>' +
      '<button class="dar-mmm__close" type="button" aria-label="Close">&times;</button></div>' +
      '<div class="dar-mmm__body"></div>';
    var body = panel.querySelector('.dar-mmm__body');

    items.forEach(function (it) {
      var label = (it.querySelector('.dar-mm__trigger') || {}).textContent || '';
      var group = document.createElement('div');
      group.className = 'dar-mmm__group';
      var head = document.createElement('button');
      head.type = 'button';
      head.className = 'dar-mmm__grouphead';
      head.innerHTML = '<span>' + label.trim() + '</span><i aria-hidden="true">+</i>';
      var list = document.createElement('div');
      list.className = 'dar-mmm__list';
      // clonar los enlaces del panel de escritorio (misma fuente de datos)
      var links = it.querySelectorAll('.dar-mm__lead-all, .dar-mm__lead a, .dar-mm__links a');
      [].forEach.call(links, function (a) {
        var c = document.createElement('a');
        c.href = a.getAttribute('href');
        c.textContent = a.textContent.trim();
        list.appendChild(c);
      });
      head.addEventListener('click', function () {
        var openNow = group.classList.toggle('is-open');
        head.querySelector('i').textContent = openNow ? '−' : '+';
      });
      group.appendChild(head); group.appendChild(list);
      body.appendChild(group);
    });

    // enlaces sueltos de la barra principal (guia de tallas, blog, contacto...).
    // En escritorio se ocultan por debajo de 1200px, pero en el panel movil deben
    // salir SIEMPRE: son el unico sitio donde quedan accesibles desde la cabecera.
    root.querySelectorAll('.dar-mm__plain').forEach(function (a) {
      var c = document.createElement('a');
      c.className = 'dar-mmm__solo';
      c.href = a.getAttribute('href'); c.textContent = a.textContent.trim();
      body.appendChild(c);
    });

    document.body.appendChild(panel);   // en BODY, no dentro del drawer del tema

    function setOpen(v) {
      panel.classList.toggle('is-open', v);
      document.documentElement.style.overflow = v ? 'hidden' : '';
      burger.setAttribute('aria-expanded', v ? 'true' : 'false');
      var ov = root.querySelector('[data-mm-overlay]');
      if (ov) { ov.hidden = !v; ov.classList.toggle('is-on', v); }
    }
    burger.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); });
    panel.querySelector('.dar-mmm__close').addEventListener('click', function () { setOpen(false); });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    var ov = root.querySelector('[data-mm-overlay]');
    if (ov) ov.addEventListener('click', function () { setOpen(false); });
  }

  /* El contador del carrito lo lleva el `cart-bubble` NATIVO del tema, que se
     hidrata desde cart-icon.js. Antes se contaba aqui parcheando window.fetch
     para enterarse de los /cart/add; se ha quitado: envolver el fetch global es
     invasivo, se pisa con el del propio tema y no aporta nada frente al bubble. */

  /* Barra pegajosa: publica su alto real en --dar-header-h (lo usan el
     scroll-padding de las anclas y el contenido sticky del tema) y marca
     `is-stuck` cuando ya hay pagina pasando por debajo, solo para la sombra. */
  function sticky(root) {
    var bar = root.querySelector('.dar-mm__bar');
    if (!bar || bar.__sticky) return;
    bar.__sticky = true;

    var util = root.querySelector('.dar-mm__utility');
    function alto() {
      var e = document.documentElement.style;
      e.setProperty('--dar-header-h', Math.round(bar.offsetHeight) + 'px');
      // en movil la franja de avisos esta oculta: offsetHeight = 0 y el `top`
      // negativo se anula solo, sin necesidad de duplicar el breakpoint aqui
      e.setProperty('--dar-util-h', Math.round(util ? util.offsetHeight : 0) + 'px');
    }
    alto();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(alto);
      ro.observe(bar);
      if (util) ro.observe(util);
    } else {
      window.addEventListener('resize', alto);
    }

    var pegada = false;
    function alScroll() {
      var ahora = bar.getBoundingClientRect().top <= 0.5;
      if (ahora === pegada) return;          // solo se toca el DOM al cambiar
      pegada = ahora;
      bar.classList.toggle('is-stuck', ahora);
    }
    alScroll();
    // OJO: aqui no scrollea la ventana sino `.page-wrapper` (el tema pone
    // overflow en html/body). El evento `scroll` no burbujea, pero en fase de
    // CAPTURA sobre document si llega venga del elemento que venga.
    document.addEventListener('scroll', alScroll, { passive: true, capture: true });
    window.addEventListener('scroll', alScroll, { passive: true });
  }

  function boot() {
    document.querySelectorAll('dar-megamenu').forEach(function (root) {
      init(root);
      sticky(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
